import { createListenerMiddleware } from '@reduxjs/toolkit';

import { AcresFeature } from '../../models/features';
import {
  addFeature,
  clearAllFeatures,
  FeatureSlice,
  removeFeatureByFeatureId,
  removeFeatureByFeatureTypeId,
  updateAllFeatures,
  updateFeatureById,
} from '../slices/featureSlice';
import { RootState } from '.';

// Create the middleware instance and methods
const addFeatureListener = createListenerMiddleware<RootState>();
const removeFeatureByIdListener = createListenerMiddleware<RootState>();
const removeFeatureByFeatureTypeIdListener =
  createListenerMiddleware<RootState>();
const clearAllFeaturesListener = createListenerMiddleware<RootState>();
const updateFeatureByIdListener = createListenerMiddleware<RootState>();
const addCustomizationListener = createListenerMiddleware<RootState>();

/**
 * Takes all of the features in the featureSlice and returns an array with all of the features
 * @param featureSlice
 * @returns
 */
function combineAllFeatures(featureSlice: FeatureSlice) {
  let allFeatures: AcresFeature[] = [];

  Object.entries(featureSlice).forEach(
    ([k, v]: [keyof FeatureSlice, AcresFeature[]]) => {
      if (k === 'allFeatures') return;

      allFeatures = allFeatures.concat(v);
    }
  );

  return allFeatures;
}

addFeatureListener.startListening({
  actionCreator: addFeature,
  effect: (_action, listenerApi) => {
    const { features } = listenerApi.getState();
    const allFeatures = combineAllFeatures(features);

    listenerApi.dispatch(updateAllFeatures(allFeatures));
  },
});

removeFeatureByIdListener.startListening({
  actionCreator: removeFeatureByFeatureId,
  effect: (_action, listenerApi) => {
    const { features } = listenerApi.getState();
    const allFeatures = combineAllFeatures(features);

    listenerApi.dispatch(updateAllFeatures(allFeatures));
  },
});

removeFeatureByFeatureTypeIdListener.startListening({
  actionCreator: removeFeatureByFeatureTypeId,
  effect: (_action, listenerApi) => {
    const { features } = listenerApi.getState();
    const allFeatures = combineAllFeatures(features);

    listenerApi.dispatch(updateAllFeatures(allFeatures));
  },
});

clearAllFeaturesListener.startListening({
  actionCreator: clearAllFeatures,
  effect: (_action, listenerApi) => {
    const { features } = listenerApi.getState();
    const allFeatures = combineAllFeatures(features);

    listenerApi.dispatch(updateAllFeatures(allFeatures));
  },
});

updateFeatureByIdListener.startListening({
  actionCreator: updateFeatureById,
  effect: (_action, listenerApi) => {
    const { features } = listenerApi.getState();
    const allFeatures = combineAllFeatures(features);

    listenerApi.dispatch(updateAllFeatures(allFeatures));
  },
});

export {
  addCustomizationListener,
  addFeatureListener,
  clearAllFeaturesListener,
  removeFeatureByFeatureTypeIdListener,
  removeFeatureByIdListener,
  updateFeatureByIdListener,
};
